import type { CountryForSelect } from 'models';

const sortCountriesByLabel = (countries: CountryForSelect[]) =>
  countries.sort((a, b) => a.label.localeCompare(b.label));

export { sortCountriesByLabel };
